<template>
  <div>
    <div v-if="show" class="credit-home" style="min-height: 100vh">
      <div
        style="width: 346px; height: 157px; margin: 0 auto; padding-top: 1rem"
      >
        <img src="../../../assets/logo.png" />
      </div>
      <div class="loading" style="margin: 0 auto">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>

      <div style="margin-bottom: 2rem; margin-top: 2rem">
        <van-button
          style="
            width: 80%;
            margin: 0 auto;
            border: 1px solid #eee;
            background-color: transparent;
            color: #fff;
          "
          round
          block
          plain
          type=""
          native-type=""
          @click="navTo('/account')"
          >Back</van-button
        >
      </div>
    </div>

    <div v-else class="credit-home">
      <div
        style="width: 346px; height: 157px; margin: 0 auto; padding-top: 1rem"
      >
        <img src="../../../assets/logo.png" />
      </div>

      <div>
        <div class="title">User personal credit score evaluation</div>

        <div class="content-form1 item" style="margin-top: 3rem">
          <div style="color: #f5ce63">Macau Grand Lisboa</div>
          <div class="">{{ reputation.searchDateString }}</div>
        </div>
        <div class="content-form" style="height: 28px; line-height: 28px">
          <div class="item">Account ID</div>
          <div class="item">{{ reputation.userId }}</div>
        </div>
        <div class="content-form" style="height: 28px; line-height: 28px">
          <div class="item">Query date</div>
          <div class="item">{{ reputation.subVisitDateString }}</div>
        </div>
        <div class="content-form" style="height: 28px; line-height: 28px">
          <div class="item">Current credit score</div>
          <div class="item">{{ reputation.currentCredit }}</div>
        </div>
        <div class="content-form" style="margin-top: 2rem">
          <div class="item">Account Balance</div>
          <div class="item">{{ reputation.balance }}</div>
        </div>
        <!-- <div class="content-form1" style="margin-top: 2rem">
          <div class="item">Credit score</div>
          <div class="item1" style="color: rgb(255, 217, 102)">
            {{ reputation.creditScore }}
          </div>
        </div> -->
        <div class="content-form1" style="margin-top: 2rem">
          <div class="item">System Reason</div>
          <div class="item1">
            {{ reputation.systemReason }}
          </div>
        </div>
        <!-- <div class="content-form1" style="margin-top: 2rem">
          <div class="item">Rating fix</div>
          <div class="item1" style="color: rgb(255, 217, 102)">
            {{ reputation.rateFix }}
          </div>
        </div> -->
      </div>

      <div style="margin-top: 1rem">
        <div class="title">Personal Repair Plan</div>

        <!-- <div class="content-form item2">
          <div style="color: #f5ce63">Macau Grand Lisboa</div>
        </div>
        <div class="content-form" style="height: 28px; line-height: 28px">
          <div class="item2">User account</div>
          <div class="item2">{{ reputation.userId }}</div>
        </div>
        <div class="content-form" style="height: 28px; line-height: 28px">
          <div class="item2">Date of visit</div>
          <div class="item2">{{ reputation.subVisitDateString }}</div>
        </div>
        <div class="content-form" style="height: 28px; line-height: 28px">
          <div class="item2">Current credit score</div>
          <div class="item2">{{ reputation.subCurrentCredit }}</div>
        </div> -->
        <div class="content-form1" style="margin-top: 2rem">
          <div class="item2">Need to fix score</div>
          <div class="item2" style="color: rgb(255, 217, 102)">
            {{ reputation.subNeedToFix }}
          </div>
        </div>
        <div class="content-form1" style="margin-top: 2rem">
          <div class="item2">Repair policy</div>
          <div
            class="item1"
            style="text-align: left; color: rgb(255, 217, 102)"
          >
            {{ reputation.subRepairProcess }}
          </div>
        </div>
        <div
          class="content-form1"
          style="margin-top: 2rem; margin-bottom: 4rem"
        >
          <div class="item2">Repair Solution</div>
          <div
            class="item1"
            style="text-align: left; color: rgb(255, 217, 102)"
          >
            {{ reputation.subRepairSolution }}
          </div>
        </div>
        <div
          class="content-form1"
          style="margin-top: 2rem; margin-bottom: 4rem"
        >
          <div class="item2">Repair Time</div>
          <div
            class="item1"
            style="text-align: left; color: rgb(255, 217, 102)"
          >
            {{ reputation.subRepairTime }}
          </div>
        </div>
      </div>

      <div style="margin-bottom: 2rem">
        <van-button
          style="
            width: 80%;
            margin: 0 auto;
            border: 1px solid #eee;
            background-color: transparent;
            color: #fff;
          "
          round
          block
          plain
          type=""
          native-type=""
          @click="navTo('/account')"
          >Back</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getCredit } from "@/common/api/api";

export default {
  name: "CreditHome",
  data() {
    return {
      reputation: {},
      show: true,
      timer: "",
    };
  },
  created() {
    const userId = this.$route.params && this.$route.params.id;
    this.getCredit(userId);
  },
  methods: {
    getCredit(userId) {
      getCredit(userId).then((res) => {
        if (res.data) {
          this.reputation = res.data;
          this.show = false;
        }
      });
    },
    navTo(path) {
      this.$router.push(path);
    },
  },
  mounted() {
    this.timer = setInterval(() => {
      if (this.show) {
        this.$toast({
          duration: 2000,
          message: "Working hard to generate, please try again later.",
        });
      }
    }, 10000);
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
};
</script>

<style scoped>
* {
  width: 100%;
}

.loading,
.loading > div {
  position: relative;
  box-sizing: border-box;
}

.loading {
  display: block;
  font-size: 0;
  color: #9370db;
}

.loading.la-dark {
  color: #333;
}

.loading > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}

.loading {
  width: 32px;
  height: 32px;
  animation: ball-spin-fade-rotate 6s infinite linear;
}

.loading > div {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 8px;
  height: 8px;
  margin-top: -4px;
  margin-left: -4px;
  border-radius: 100%;
  animation: ball-spin-fade 1s infinite linear;
}

.loading > div:nth-child(1) {
  top: 5%;
  left: 50%;
  animation-delay: -1.125s;
}

.loading > div:nth-child(2) {
  top: 18.1801948466%;
  left: 81.8198051534%;
  animation-delay: -1.25s;
}

.loading > div:nth-child(3) {
  top: 50%;
  left: 95%;
  animation-delay: -1.375s;
}

.loading > div:nth-child(4) {
  top: 81.8198051534%;
  left: 81.8198051534%;
  animation-delay: -1.5s;
}

.loading > div:nth-child(5) {
  top: 94.9999999966%;
  left: 50.0000000005%;
  animation-delay: -1.625s;
}

.loading > div:nth-child(6) {
  top: 81.8198046966%;
  left: 18.1801949248%;
  animation-delay: -1.75s;
}

.loading > div:nth-child(7) {
  top: 49.9999750815%;
  left: 5.0000051215%;
  animation-delay: -1.875s;
}

.loading > div:nth-child(8) {
  top: 18.179464974%;
  left: 18.1803700518%;
  animation-delay: -2s;
}

.loading.la-sm {
  width: 16px;
  height: 16px;
}

.loading.la-sm > div {
  width: 4px;
  height: 4px;
  margin-top: -2px;
  margin-left: -2px;
}

.loading.la-2x {
  width: 64px;
  height: 64px;
}

.loading.la-2x > div {
  width: 16px;
  height: 16px;
  margin-top: -8px;
  margin-left: -8px;
}

.loading.la-3x {
  width: 96px;
  height: 96px;
}

.loading.la-3x > div {
  width: 24px;
  height: 24px;
  margin-top: -12px;
  margin-left: -12px;
}

@keyframes ball-spin-fade-rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes ball-spin-fade {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.25;
    transform: scale(0.5);
  }
}
</style>

<style lang="scss">
.credit-home {
  background-image: url("../../../assets/bg.png");
  background-size: 100% 100%;
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
  color: #fff;

  .title {
    font-family: Comic Sans MS;
    font-size: 28px;
    font-weight: 500;
    height: 40px;
  }

  .content-form {
    font-family: Microsoft YaHei;
    // height: 28px;
    min-height: 28px;
    display: flex;
    margin-top: 1rem;
    // text-align: center;
    align-items: center;
    justify-content: center;
  }

  .content-form1 {
    font-family: Microsoft YaHei;
    // height: 28px;
    min-height: 28px;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    // text-align: center;
    align-items: center;
    justify-content: center;
  }
}

.item {
  position: relative;
  border: 1px solid #03a9f3;
  border-radius: 10%;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 0px;
    height: 20px;
  }

  &::before {
    top: 0px;
    left: px;
    border-top: 1px solid var(--borderColor);
    border-left: 1px solid var(--borderColor);
  }

  &::after {
    right: 0px;
    bottom: 0px;
    border-bottom: 1px solid var(--borderColor);
    border-right: 1px solid var(--borderColor);
  }

  &:hover::before,
  &:hover::after {
    width: calc(100%);
    height: calc(100% + 9px);
  }
}

.item2 {
  position: relative;
  border: 1px solid #5a5959;
  border-radius: 10%;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 0px;
    height: 20px;
  }

  &::before {
    top: 0px;
    left: 0px;
    border-top: 1px solid var(--borderColor);
    border-left: 1px solid var(--borderColor);
  }

  &::after {
    right: 0px;
    bottom: 0px;
    border-bottom: 1px solid var(--borderColor);
    border-right: 1px solid var(--borderColor);
  }

  &:hover::before,
  &:hover::after {
    width: calc(100%);
    height: calc(100% + 9px);
  }
}
</style>
